import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

interface ProgressBarProps {
  /** Avance de 0 a 100. Fuera de rango se recorta. */
  value: number;
  /** Texto a la derecha de la barra. Sin él, solo se pinta la barra. */
  label?: string;
}

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 9,
  width: '100%',
});

const Track = styled.div({
  flex: 1,
  height: 6,
  borderRadius: 3,
  background: t.color.segmentTrack,
  overflow: 'hidden',
});

const Fill = styled.div<{ value: number }>(({ value }) => ({
  height: '100%',
  width: `${value}%`,
  borderRadius: 3,
  background: t.color.primary,
  transition: 'width 0.25s ease',
}));

const Label = styled.span({
  fontFamily: t.font,
  fontSize: 10.5,
  fontWeight: 600,
  color: t.color.muted,
  whiteSpace: 'nowrap',
});

/**
 * Primitivo: barra de avance.
 *
 * Lleva `role="progressbar"` con sus valores: el avance es información, no
 * decoración, y sin los atributos un lector de pantalla solo anuncia dos cajas
 * vacías.
 */
const ProgressBar = ({ value, label }: ProgressBarProps) => {
  const clamped = Math.min(100, Math.max(0, Math.round(value)));

  return (
    <Row>
      <Track role="progressbar" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={100}>
        <Fill value={clamped} />
      </Track>
      {label ? <Label>{label}</Label> : null}
    </Row>
  );
};

export default ProgressBar;
